import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';

const AgeVerification = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already verified age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowPopup(true);
    }
  }, []);

  const handleConfirmAge = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowPopup(false);
  };

  const handleRejectAge = () => {
    // Redirect to a safe page or show message
    window.location.href = 'https://www.begambleaware.org';
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4">
        <div className="bg-book-brown text-book-cream p-6 rounded-t-xl">
          <div className="flex items-center space-x-3">
            <Shield className="h-8 w-8" />
            <h2 className="text-xl font-bold">Age Verification Required</h2>
          </div>
        </div>

        <div className="p-6">
          <div className="text-center mb-6">
            <p className="text-gray-700 text-lg mb-4">
              Welcome to Brit Ember
            </p>
            <p className="text-gray-600 mb-4">
              To access our casino aggregation services, you must be 18 years of age or older.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              By continuing, you confirm that you are 18 years of age or older and agree to our responsible gaming policies.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleConfirmAge}
              className="w-full bg-book-brown text-book-cream py-3 px-4 rounded-lg font-semibold hover:bg-book-brown-light transition-colors duration-200"
            >
              I am 18 or older - Continue
            </button>
            <button
              onClick={handleRejectAge}
              className="w-full bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-300 transition-colors duration-200"
            >
              I am under 18 - Exit Site
            </button>
          </div>

          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              For responsible gaming support, visit{' '}
              <a
                href="https://www.begambleaware.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-book-brown hover:underline"
              >
                BeGambleAware.org
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;
